'use client';

import dynamic from 'next/dynamic';

interface ThemeSwitcherProps {
  className?: string;
}

// Use dynamic import to prevent hydration issues with localStorage
const DynamicThemeSwitcher = dynamic(
  () =>
    import('@/app/_lib/ui/ThemeSwitch').then((mod) => ({
      default: mod.ThemeSwitcher,
    })),
  {
    ssr: false,
    loading: () => <div className='h-4 w-4'></div>, // Placeholder with same dimensions as icon
  },
);

export function ThemeSwitcherWrapper(props: ThemeSwitcherProps) {
  return <DynamicThemeSwitcher {...props} />;
}
